import React from 'react'
import { Helmet } from 'react-helmet-async'

const PrivacyPage: React.FC = () => (
  <>
    <Helmet>
      <title>Privacy Policy - AI Decision Maker | Free Online Decision Assistant</title>
      <meta name="description" content="Privacy Policy for AI Decision Maker. Learn how we protect your data and privacy while using our free online decision assistant and AI decision maker tools." />
      <meta name="keywords" content="ai decision maker privacy, decision assistant privacy policy, data protection, privacy policy, ai decision maker security" />
      <meta property="og:title" content="Privacy Policy - AI Decision Maker" />
      <meta property="og:description" content="Privacy Policy for AI Decision Maker. Learn how we protect your data and privacy while using our free online decision assistant." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://aidecision.org/privacy" />
      <meta name="twitter:title" content="Privacy Policy - AI Decision Maker" />
      <meta name="twitter:description" content="Privacy Policy for AI Decision Maker. Learn how we protect your data and privacy." />
      <link rel="canonical" href="https://aidecision.org/privacy" />
      
      {/* Structured Data for Privacy Page */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Privacy Policy - AI Decision Maker",
          "description": "Privacy Policy for AI Decision Maker - free online decision assistant",
          "url": "https://aidecision.org/privacy",
          "mainEntity": {
            "@type": "Organization",
            "name": "AI Decision Maker",
            "url": "https://aidecision.org"
          }
        })}
      </script>
    </Helmet>

    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-900">Privacy Policy - AI Decision Maker</h1>
      <p className="mb-4 text-gray-700 text-lg">
        Your privacy is important to us. This Privacy Policy explains how AI Decision Maker collects, uses, and protects your information when using our free online decision assistant and AI decision maker tools.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
      <p className="mb-2 text-gray-700">We do <strong>not</strong> collect any personal information. All decision options and results are stored locally in your browser and are never transmitted to our servers.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">2. Use of Information</h2>
      <p className="mb-2 text-gray-700">Your data is used solely for providing the decision-making functionality within your browser. We do not use your data for advertising, analytics, or any third-party purposes.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">3. Data Security</h2>
      <p className="mb-2 text-gray-700">We implement industry-standard security measures to protect your information. However, since all data is stored locally, please ensure your device is secure.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">4. User Rights</h2>
      <p className="mb-2 text-gray-700">You have full control over your data. You can clear your options and results at any time using the app's features.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">5. Changes to This Policy</h2>
      <p className="mb-2 text-gray-700">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">6. Contact</h2>
      <p className="mb-2 text-gray-700">If you have any questions or concerns about this policy, please contact us at <a href="mailto:support@aidecision.org" className="text-blue-600 underline">support@aidecision.org</a>.</p>
      <p className="text-gray-500 text-sm mt-8">Effective date: July 2024</p>
    </div>
  </>
)

export default PrivacyPage 